import axios from 'axios';
import { handleUnauthorized } from './wrappers';

export const request = (options: any, token?: string) => {
  return axios({
    baseURL: `${process.env.REACT_APP_BASE_URL}/`,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: token,
    },
    responseType: 'json',
    ...options,
  });
};

export default handleUnauthorized(request);
